<!--历年发放行驶证数量 -->
<template>
  <div id="line-chart" :style="{ height: height, width: width }" />
</template>
<script>
import * as echarts from 'echarts';
import resize from "@/components/chart/mixins/resize";
let chartVm = null;
function toThousandFilter (num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}
export default {
  mixins: [resize],
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    chartData: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      chart: null,
      yearData: [],
      data1: [],
      options: {
        legend: {
          top: '4px',
          icon: 'rect',
          itemWidth: 12,         // 图标宽度
          itemHeight: 4,         // 图标高度
          right: '16px',
          selected: {
            hide: false
          },
          textStyle: {
            color: '#fff',
            fontFamily: 'Microsoft YaHei',
            fontSize: 12
          }
        },
        tooltip: {
          trigger: 'axis',
          padding: 8,
          backgroundColor: 'rgba(0, 31, 11, 0.8)',
          formatter: function(params) {
            let html = `<div>${params[0].name}年</div>`;
            params.forEach(param => {
              let marker = `<span style="display:inline-block;margin-bottom: 3px;margin-right:5px;width:12px;height:4px;border-radius: 1px;background-color:${param.color}"></span>`
              html += `${marker} ${param.seriesName}： ${toThousandFilter(param.value || 0)} 本</br>`; // 示例：添加百分比符号
            });
            return html;
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: new echarts.graphic.LinearGradient(0,0,0,1, 
                //渐变色在下面修改，这里是透明度
                [
                  {
                    offset: 0,
                    color: 'rgba(0, 255, 132, 0.1)',
                  },
                  {
                    offset: 1,
                    color: 'rgba(0, 255, 132, 1)',
                  },
                ]
              )
            }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [],
          axisTick: {
            show: false
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(161, 207, 219, 0.15)',
              type: 'solid'
            }
          },
          axisLabel: {
            show: true,
            color: '#BABBBD',
            fontSize: 12,
            fontFamily: 'Microsoft YaHei',
            margin: 16
          }
        },
        yAxis: {
          name: '(本)',
          nameTextStyle: {
            color: '#BABBBD',
            fontSize: 12,
            align: 'right',
            padding: [0, 24, 0, 0],
          },
          type: 'value',
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: 'rgba(161, 207, 219, 0.15)',
              type: 'solid'
            }
          },
          axisLabel: {
            color: '#BABBBD',
            formatter: '{value}',
            fontSize: 12,
            fontFamily: 'MicrosoftYaHei'
          }
        },
        grid: {
          top: '40px',
          left: '60px',
          right: '21px',
          bottom: '18%'
        }
      }
    };
  },
  activated() {
    this.$nextTick(function () {
      setTimeout(() => {
        this.chart.resize();
      }, 300);
    });
  },
  watch: {
    chartData() {
      this.yearData = this.chartData.map(item => {
        return item.name;
      })
      this.data1 = this.chartData.map(item => {
        return item.value
      })
      this.initChart()
    }
  },
  mounted() {
    this.chartData.map(item => {
      this.yearData.push(item.name)
      this.data1.push(item.value)
    })
    this.initChart();
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    setChartData() {
      let series = [];
      let that = this;
      series.push({
        name: '发放数量',
        data: this.data1,
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 1,
        itemStyle: {
          color: 'rgba(38, 255, 114, 1)',
          emphasis: {           // 悬停状态配置
            color: '#FFFFFF',   // 悬停填充色
            borderColor: 'rgba(98, 255, 153, 0.2)',
            borderWidth: 6,
            shadowBlur: 6,     // 阴影模糊度
            shadowColor: 'rgba(98, 255, 153, 1)',
            symbolSize: 10      // 悬停时图标放大
          }
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: 'rgba(32, 214, 96, 0.05)' },
            { offset: 1, color: 'rgba(32, 214, 96, 0.2)' }
          ])
        }
      });
      this.options.xAxis.data = this.yearData;
      this.options.series = series;
      this.chart.setOption(this.options);
    },
    initChart() {
      if (!this.chart) {
        this.chart = echarts.init(document.getElementById('line-chart'));
      }
      this.setChartData();
    },
  },
};
</script>
